/* eslint-disable */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import caretUp from '../../assets/navbar/caretUp.png';
import caretDown from '../../assets/navbar/caretDown.png';
import Profilepic from '../../assets/user/profile.png';
import styles from './dropdown.module.scss';
import navstyles from '../navbar/navbar.module.scss';
import { useUserStore } from '../../store';

const DropdownComponent = ({ data, active, setActive }) => {
  const user = useUserStore((s) => s.user);
  const [click, setClick] = useState(false);
  const [image, setImage] = useState(Profilepic);

  useEffect(() => {
    if (user.avatar_url) {
      setImage(user.avatar_url);
    }
  }, [user]);

  useEffect(() => {
    const handleClickOutside = () => {
      setActive('');
      setClick(click);
    };
    document.body.addEventListener('click', handleClickOutside);

    return () => {
      document.body.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const onHeadingClick = (e) => {
    setActive(data.heading);
    setClick(!click);
    e.stopPropagation();
  };

  return (
    <li className={navstyles['navigation-bar-item']} onClick={onHeadingClick}>
      <div className={navstyles['navigation-bar-links']}>
        {data.img && (
          <img
            src={image}
            style={{ height: '40px', width: '40px', marginRight: '5px', borderRadius: '50%' }}
            alt="userProfile"
          />
        )}
        {user.id && data.id === 'user'
          ? `${user.first_name} ${user.last_name}`
          : data.id === 'My Program'
          ? data.heading
          : 'User'}
        {click ? <img src={caretUp} alt="caretUp" /> : <img src={caretDown} alt="caretDown" />}
        {active === data.heading && (
          <ul
            style={{ display: click ? '' : 'none' }}
            className={`${styles['dropdn-menu']} ${click ? styles.clickd : ''}`}>
            {data.content.map((e) => (
              <li key={e.id}>
                {e.path !== '/resources' ? (
                  <Link
                    to={e.path}
                    onClick={() =>
                      e.path === '/settings' ? localStorage.removeItem('gameSettingClicked') : null
                    }
                    className={styles[e.cName]}>
                    <img
                      className={styles[e.className]}
                      style={{ height: '30px', width: '30px' }}
                      alt={e.id}
                      src={e.src}
                      key={e.id}
                    />
                    {e.title}
                  </Link>
                ) : (
                  <Link
                    to={{ pathname: 'https://gamitar.freshdesk.com/support/home' }}
                    target="_blank"
                    className={styles[e.cName]}>
                    <img
                      className={styles[e.className]}
                      style={{ height: '30px', width: '30px' }}
                      alt={e.id}
                      src={e.src}
                      key={e.id}
                    />
                    {e.title}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </li>
  );
};

DropdownComponent.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]).isRequired,
  active: PropTypes.string.isRequired,
  setActive: PropTypes.func.isRequired,
};

export default DropdownComponent;
